<template>
  <v-app id="backGND">
    <navBar />
    <div id="triangle_down">
      <div id="triangle">
        <h1
          class="rotate"
          style="
            margin: auto;
            text-align: left;
            font-family: 'Poiret One', sans-serif;
            color: white;
            padding-left: 1rem;
            font-size: 3rem;
          "
        >
          Confirmación de Pago
        </h1>
      </div>

      <v-card
        elevation="25"
        color="rgba(255,255,255,1)"
        class="blue-grad mx-auto"
        style="
          margin: 1rem;
          border-top-left-radius: 2.5rem;
          border-top-right-radius: 2.5rem;
          border-bottom-left-radius: 2.5rem;
          border-bottom-right-radius: 2.5rem;
          margin-bottom: 2rem;
        "
        max-width="700"
      >
        <v-container v-if="flagPaid">
          <v-row dense>
            <v-col cols="12">
              <v-card-title
                style="
                  font-size: 2.5rem;
                  font-family: Poiret One;
                  white-space: pre-wrap;
                  word-break: break-word;
                "
              >
                <b>{{ title }}</b>
              </v-card-title>
              <div
                id="divider"
                style="
                  background-color: black;
                  height: 0.5rem;
                  width: 80%;
                  margin: auto;
                "
              ></div>
              <v-card-subtitle
                style="
                  font-size: 2rem;
                  font-family: Poiret One;
                  color: #c2958e;
                  margin-bottom: 0.2rem;
                "
              >
                <b>{{ subtitle }}</b>
              </v-card-subtitle>
              <v-card-subtitle
                style="
                  font-size: 1.5rem;
                  font-family: Poiret One;
                  color: #c2958e;
                "
              >
                <br />
                <a
                  style="
                    font-size: 1.5rem;
                    color: black;
                    font-family: Poiret One;
                  "
                  ><b>{{ msj }}</b></a
                >
                <br>
                <br>
                <br>
                <a
                  style="
                    font-size: 1.5rem;
                    color: blue;
                    font-family: Poiret One;
                  "
                  href="https://barrepro.com.mx"
                  >Inicio</a
                >
              </v-card-subtitle>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </div>
  </v-app>
</template>
  <script>
import navBar from "@/components/navbar";
import { db } from "@/main";
export default {
  components: { navBar },
  data() {
    return {
      flagPaid: null,
      title: null,
      subtitle: null,
      msj: null,
    };
  },
  mounted() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const order_id = urlParams.get("order_id");
    let that = this;
    fetch("https://barrepro-api.onrender.com/getOrder/" + order_id)
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data.payment == "paid") {
          that.addPackageToUsers(data.amount);
          that.title = "●FELICIDADES TU PAGO SE HA PROCESADO CON ÉXITO●";
          that.subtitle = "😄 Ya puedes continuar con tus clases";
          that.msj =
            "Si aun no puedes acceder al contenido, por favor refresca la pagino o cierra sesión y vuelve a iniciar. En caso de seguir presentado algún error por favor ponte en contacto con nosotros";
          that.flagPaid = true;
        } else {
          that.title = "ALGO SALIO MAL AL PROCESAR TU PAGO";
          that.subtitle = "😣 Lo siento, aun no puedes continuar tus clases";
          that.msj =
            "Si esto se trata de un error, por favor ponte en contacto con nosotros para poder hacer una revisión manual de tu pago. Gracias por entender";
          that.flagPaid = true;
        }
      });
  },
  methods: {
    addPackageToUsers: async function (amount) {
      var packages = [];
      var date = new Date();
      var date_end = new Date();

      await db
        .collection("users")
        .doc(this.$store.state.authModule.user.uid)
        .get()
        .then((doc) => {
          if (doc.data().packages) {
            packages = doc.data().packages;
          }
        });

      let lastElement = packages.slice(-1);
      let endLastPackageDate = lastElement[0].package_end

      if (date < endLastPackageDate.toDate()){
        if (amount == 44100) {
        var p = {
          package_name: "Mensual",
          package_price: 420,
          package_start: endLastPackageDate,
          package_end: new Date(endLastPackageDate.toDate().setMonth(endLastPackageDate.toDate().getMonth() + 1)),
        };

        packages.push(p);
      } else if (amount == 113900) {
        var p = {
          package_name: "Trimestral",
          package_price: 1090,
          package_start: endLastPackageDate,
          package_end: new Date(endLastPackageDate.toDate().setMonth(endLastPackageDate.toDate().getMonth() + 3)),
        };

        packages.push(p);
      } else if (amount == 218000) {
        var p = {
          package_name: "Medio Año",
          package_price: 2090,
          package_start: endLastPackageDate,
          package_end: new Date(endLastPackageDate.toDate().setMonth(endLastPackageDate.toDate().getMonth() + 6)),
        };

        packages.push(p);
        //  }
      }
      } else {
        if (amount == 44100) {
        var p = {
          package_name: "Mensual",
          package_price: 420,
          package_start: date,
          package_end: new Date(date_end.setMonth(date_end.getMonth() + 1)),
        };

        packages.push(p);
        } else if (amount == 113900) {
          var p = {
            package_name: "Trimestral",
            package_price: 1090,
            package_start: date,
            package_end: new Date(date_end.setMonth(date_end.getMonth() + 3)),
          };

          packages.push(p);
        } else if (amount == 218000) {
          var p = {
            package_name: "Medio Año",
            package_price: 2090,
            package_start: date,
            package_end: new Date(date_end.setMonth(date_end.getMonth() + 6)),
            };

            packages.push(p);
        //  }
        }
      }      

      var data = {
        packages: packages,
      };


      await db
        .collection("users")
        .doc(this.$store.state.authModule.user.uid)
        .set(data, { merge: true })
        .then(() => {})
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
  <style scoped>
#backGND {
  background-image: url("../assets/back.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  margin-top: auto;
}
#triangle_down {
  height: 10rem;

  background: linear-gradient(
    to top right,
    rgba(255, 0, 0, 0) 0%,
    rgba(255, 0, 0, 0) 50%,
    rgba(200, 200, 200, 1) 50%,
    rgba(200, 200, 200, 1) 100%
  );
}
#triangle {
  height: 10rem;
  background: linear-gradient(
    to top left,
    rgba(255, 0, 0, 0) 0%,
    rgba(255, 0, 0, 0) 50%,
    #000000 50%,
    #000000 100%
  );
}
.rotate {
  transform: rotate(-5deg);
}
</style>
  


// WEBPACK FOOTER //
// src/components/afterPayment.vue